import Axios from "axios";
import sampleList from "./sampleList";
import { computed } from 'vue';

export const monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

export async function get_cps_supplements(all_supplement_topics_ref, grid_ref, default_picked=true) {
  const topicsExcludeList = ["Basic Monthly"];
  const sampleList = await getSamples("cps", false, topicsExcludeList);

  for (let i = 0; i < sampleList.topics.length; i++) {
    const topic = sampleList.topics[i];
    all_supplement_topics_ref.value[topic] = {
      index: i,
      name: topic,
      picked: default_picked
    }
  }

  if (grid_ref) {
    for (let sample in sampleList.samples) {
      const year = sample.year;
      const month_index = sample.month - 1;
      if (grid_ref.value[year]) {
        grid_ref.value[year].months[month_index].topics.push(...sample.supplement_topics);
      }
    }
  }

  return sampleList;
}

export async function get_atus_samples() {
  const sampleList = await getSamples("atus", true, []);

  const modules = {};
  const samples = {};
  sampleList.samples.forEach((s) => {
    samples[s.year] = {name: s.year, picked: false, modules: new Set()};
    s.supplement_topics.forEach((st) => {
      if (!modules[st]) {
        modules[st] = {name: st, picked: false, years: new Set()};
      }
      modules[st].years.add(s.year);
      samples[s.year].modules.add(st);
    });
  });
  return [modules, samples];
}

export async function get_atus_cps_linking_counts() {
  try {
    const axios_instance = get_axios();
    const response = await axios_instance.get(`api/atus_linking_counts`);
    return response.data;
  } catch (error) {
    console.log(error);
    alert("The app is currently unavailable. Please check back later.");
    return null;
  }
}

const plainIntegerFormat = new Intl.NumberFormat('en-US', { maximumFractionDigits: 0 });

export function formatInteger(num) {
  return plainIntegerFormat.format(num);
}

export function getBaseUrl() {
  return document.getElementById("config").dataset.url;
}

export function useSelectedSampleTopics({
    cps_sample_list,
    cps_supplement_topics,
    year,
    month
}) {
    const selectedSampleTopics = computed(() => {
        const sampleTopics = cps_sample_list.value?.getTopics(year.value, month.value + 1) || [];
        const selectedTopics = new Set();
        for (let [_, topicEntry] of Object.entries(cps_supplement_topics.value)) {
            if (topicEntry.picked) {
                selectedTopics.add(topicEntry.name);
            }
        }
        return sampleTopics.filter(t => selectedTopics.has(t));
    });
    return selectedSampleTopics;
}

export function makeTooltipData(data = {}) {
    const dataDefaults = {
        month: 0,
        year: 0,
        linkingCounts: {},
        selectedSampleTopics: [],
        bottom: 0,
        left: 0,
        show_tooltip: false
    }
    return {...dataDefaults, ...data}
}

async function getSamples(product, includeNonTopicSamples, topicsExcludeList) {
  try {
    const axios_instance = get_axios();
    const response = await axios_instance.get(`api/metadata/v1/samples/sample_topics.json?product=${product}&include_non_topic_samples=${includeNonTopicSamples}`);
    return new sampleList(response.data, topicsExcludeList);
  } catch (error) {
    console.log(error);
    alert("The app is currently unavailable. Please check back later.");
    return null;
  }
}

function get_axios() {
    return Axios.create({
        baseURL: getBaseUrl(),
        headers: {'X-Requested-With': 'XMLHttpRequest', 'X-CSRF-TOKEN' : document.getElementById("config").dataset.csrfToken}
    });
}

